import * as types from './actionTypes';
import { handleError } from '../errors/handleError';
import { getMedia } from '../apis/MediaApi';
import { addAlert, clearAlert } from './alertActions';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function getProjectMedia(projectId) {
    return function (dispatch) {
        dispatch({
            type: types.GET_PROJECT_MEDIA_PENDING,
        });
        return getMedia(projectId)
            .then((response) => {
                dispatch({
                    type: types.GET_PROJECT_MEDIA_SUCCESS,
                    payload: response.data.data,
                });
                dispatch(clearAlert('sermon-media-invalid'));
            })
            .catch((error) => {
                if (error.response && error.response.status !== 404) {
                    dispatch(addAlert({
                        message: error,
                        view: '/modules/sermons',
                        type: 'error',
                        dismissable: true,
                        id: 'sermon-media-invalid',
                    }));
                }
                errorHandler(dispatch, error, types.GET_PROJECT_MEDIA_FAILED);
            });
    };
}
